var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flashed-messages"},[_c('transition-group',{attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.flashedMessages),function(msg){return _c('p',{key:msg.id,class:msg.msgType},[_vm._v("\n      "+_vm._s(msg.msg)+"\n      "),_c('span',{staticClass:"close-x",on:{"click":function($event){_vm.close(msg)}}},[_vm._v("×")])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9809e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlashedMessages.vue
// module id = null
// module chunks = 